import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '@/app/shared/ui/notifications/toast.service';
import {
  STAFF_BATCH_LIMIT_EXCEEDED_REASON,
  StaffBatchLimitExceededDetails,
} from '../models/staff.model';

export interface StaffBatchLimitExceededNotice {
  title: string;
  description: string;
}

export function staffBatchLimitExceededNotice(
  cause: unknown,
): StaffBatchLimitExceededNotice | null {
  const details = batchLimitExceededDetails(cause);
  if (!details) return null;

  return {
    title: 'El archivo supera el máximo de registros permitido',
    description:
      (details.totalRecords === undefined
        ? `El máximo permitido por carga es ${details.maxRecords} registros. `
        : `Tiene ${details.totalRecords} registros, pero el máximo permitido por carga es ${details.maxRecords}. `) +
      `Divide el archivo en partes de ${details.maxRecords} registros o menos y procesa cada una por separado.`,
  };
}

type BatchLimitExceededWireDetails = Partial<
  Omit<StaffBatchLimitExceededDetails, 'totalRecords'>
> & {
  totalRecords?: number | null;
};

function batchLimitExceededDetails(cause: unknown): StaffBatchLimitExceededDetails | null {
  if (!(cause instanceof HttpErrorResponse) || cause.status !== 400) return null;

  const details = (cause.error as { error?: { details?: BatchLimitExceededWireDetails } } | null)
    ?.error?.details;
  const totalRecords = details?.totalRecords ?? undefined;

  if (
    details?.reason !== STAFF_BATCH_LIMIT_EXCEEDED_REASON ||
    (totalRecords !== undefined && typeof totalRecords !== 'number') ||
    typeof details.maxRecords !== 'number'
  ) {
    return null;
  }
  return { reason: details.reason, totalRecords, maxRecords: details.maxRecords };
}

export function notifyStaffBatchLimitExceeded(toasts: ToastService, cause: unknown): boolean {
  const notice = staffBatchLimitExceededNotice(cause);
  if (!notice) return false;
  toasts.error(notice.title, { description: notice.description, persistent: true });
  return true;
}
